import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { GroupVsRemainder } from './types';

const buildQuery = ({
  filterInput,
  dateScope,
  peerGroupField,
  dateInterval,
  fiscalInterval,
  dataType,
  field,
  selectedEntities,
}: GroupVsRemainder.RequestArguments) => {
  return {
    query: gql`
      query groupVsRemainderAggregation(
        $filters: [FilterInput]!
        $dateScope: [DateRangeInput!]!
        $dateInterval: Interval
        $fiscalInterval: FiscalInterval
        $peerGroupField: String
        $selectedEntities: FilterInput
        $field: String!
        $dataType: String!
      ) {
        groupVsRemainderAggregation(
          dateScope: $dateScope
          filters: $filters
          dateInterval: $dateInterval
          fiscalInterval: $fiscalInterval
          selectedEntities: $selectedEntities
          peerGroupField: $peerGroupField
          field: $field
          dataType: $dataType
        )
      }
    `,
    variables: {
      filters: filterInput,
      dateScope,
      dateInterval,
      fiscalInterval,
      peerGroupField,
      field,
      dataType,
      selectedEntities,
    },
  };
};

const getGroupVsRemainder = async ({
  filterInput,
  dateScope,
  peerGroupField,
  selectedEntities,
  dateInterval,
  fiscalInterval,
  dataType,
  field,
  client,
}: GroupVsRemainder.RequestArguments & {
  client: ApolloClient<NormalizedCacheObject>;
}): Promise<GroupVsRemainder.Response> => {
  const query = buildQuery({
    filterInput,
    dateScope,
    dateInterval,
    fiscalInterval,
    dataType,
    field,
    peerGroupField,
    selectedEntities,
    client,
  });

  const response = await client.query(query);
  return response.data.groupVsRemainderAggregation;
};

export default getGroupVsRemainder;
